var $d96d7e2b61e8613f$exports = {};
$d96d7e2b61e8613f$exports = {
    "collapse": `Comprimi`,
    "expand": `Espandi`
};


export {$d96d7e2b61e8613f$exports as default};
//# sourceMappingURL=it-IT.mjs.map
